module.exports = __webpack_public_path__ + "static/media/green-increase-indicator.1f9243d6.svg";